import ForgetPassword from "../../section/auth/ForgetPassword";

export default function ForgetPwd(){
    return(
        <ForgetPassword />
    )
}